<!-- 
  @desc 中央本级
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'中央本级'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4" v-loading="!this.dictAll.sportCenter">
          <left-select :chooseList="this.dictAll.sportCenter" @chooseValue="chooseValue" :orgId="orgId"></left-select>
        </el-col>
        <el-col :span="20">
          <!-- <approve-msg :approveList="approveList"></approve-msg> -->
          <el-row class="list_content">
            <el-tabs v-model="activeTab" class="tab" @tab-click="handleClick">
              <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.label" :name="item.name">
                <component
                  class="qssComponent"
                  v-bind:is="item.content"
                  :isHideBreadMenu="true"
                  :orgId="orgId"
                  v-if="activeTab === item.name"
                ></component>
              </el-tab-pane>
            </el-tabs>
          </el-row>
        </el-col>
      </el-row>
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import TitleBar from "@/components/public/TitleBar.vue";
import LeftSelect from "@/components/public/LeftSelect.vue";
import ApproveMsg from "@/components/public/ApproveMsg.vue";
import Game from "@/components/game/u/game/Index.vue";
import Traincamp from "@/components/traincamp/Index.vue";
import Campus from "@/components/game/campus/Index.vue";
import Club from "@/components/game/club/Index.vue";

export default {
  components: {
    TitleBar,
    LeftSelect,
    ApproveMsg,
    Game,
    Traincamp,
    Campus,
    Club
  },
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**审批信息列表 */
      approveList: {},
      /**tab导航配置 */
      activeTab: "game",
      tabs: [
        {
          label: "U系列比赛",
          name: "game",
          content: Game
        },
        {
          label: "精英训练营",
          name: "traincamp",
          content: Traincamp
        },
        {
          label: "体教融合专项赛事",
          name: "campus",
          content: Campus
        }
        // {
        //   label: "俱乐部比赛",
        //   name: "club",
        //   content: Club
        // }
      ],
      /**当前选中单位主键 */
      orgId: ""
    };
  },
  computed: {
    ...mapGetters(["dictAll", "dict"])
  },
  mounted() {
    /**设置默认选项 */
    this.activeTab = this.$route.query.type ? this.$route.query.type : this.activeTab;
  },
  methods: {
    handleClick() {
      // this.$router.push({
      //   path: this.$route.meta.index,
      //   query: { type: tab.name }
      // });
    },
    /**选择左边的项目中心列表 */
    chooseValue(value) {
      this.orgId = value;
    }
  }
};
</script>
